export default __webpack_public_path__ + "static/media/pics_72.dab06db3.jpg";